<div class="page-container">
 <app-header></app-header>
  <viz-container>
    <viz-main-content>
      <router-outlet></router-outlet>
    </viz-main-content>
  </viz-container>
  <viz-footer [contactLink]="email"
              contactDisplay="Contact Us"
              appTitle={{title}}
              copyright="Vizient Inc. All Rights Reserved">
  </viz-footer>
</div>
